import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UniversitySliderCopy } from '../../models/university-slider.models';
import { NgClass } from '@angular/common';

@Component({
	selector: 'uc-cta-container',
	templateUrl: './cta-container.component.html',
	imports: [NgClass],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaContainerComponent {
	uniSliderCopy = input<UniversitySliderCopy>();
	tab = input<string>();
}
